<template>
  <div class="view">
    <header class="m-header flexsb">
      <div class="left flexa">
        <span>合計費用：</span>
        <span class="amount">{{ amount }}</span>
        <span>{{ currency }}</span>
      </div>
      <div class="right flexa">
        <span>需支付：</span>
        <span class="amount">{{ amount }}</span>
        <el-select
          v-model="currency"
          placeholder="請選擇"
          style="width: 100px"
          @change="getAmount"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :value="item.value"
            disabled
          ></el-option>
        </el-select>
      </div>
    </header>
    <div class="pay-box flex">
      <div class="label">支付宝支付</div>
      <div class="code-box">
        <!-- <div class="tips">
          <span>距离二维码过期还剩</span>
          <span>{{ count }}</span>
          <span>秒，过期后请刷新页面重新获取二维码。</span>
        </div> -->
        <div class="qr-code">
          <iframe
            id="iframe"
            style="display: block; float: left"
            :srcdoc="code"
            frameborder="0"
            height="205px"
            width="205px"
          ></iframe>
        </div>
        <div class="scan-btn flexa">
          <img src="@/assets/images/bank/scan.png" height="32" width="32" />
          <div class="flexc">
            <span>请使用支付宝扫一扫</span>
            <span>扫描二维码支付</span>
          </div>
        </div>
        <div class="paid-box">
          <span class="paid" @click="queryPayResult">我已完成支付</span>
        </div>
      </div>
      <div class="flexc" style="">
        <img src="@/assets/images/bank/ali_scan.png" />
        <span class="link" @click="back">{{ str }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      code: "",
      isCounting: false,
      isValid: true,
      clock: null,
      count: 60,
      payDetail: {},
      payParams: {},
      str: "<<選擇其他方式支付",
      index: 0,
      amountList: [{ amount: 0 }],
      amount: "",
      currency: "HKD",
      options: [
        {
          value: "HKD"
        },
        {
          value: "CNY"
        }
      ]
    };
  },
  mounted() {
    this.getPrice();
    this.code = JSON.parse(sessionStorage.getItem("qrcode"));
    // this.$nextTick(() => {
    //   const iframe = document.getElementById("iframe");
    //   const iwindow = iframe.contentWindow;
    //   const idoc = iwindow.document;
    //   // idoc.getElementById("payForm").submit();
    // });
    // let divForm = document.getElementsByTagName("divform");
    // if (divForm.length) {
    //   document.body.removeChild(divForm[0]);
    // }
    // const div = document.createElement("divform");
    // div.innerHTML = this.code; // res.data就是sb支付宝返回给你的form
    // document.body.appendChild(div);
    // // document.forms[0].setAttribute('target', '_blank') // 加了_blank可能出问题所以我注释了
    // document.getElementById("payForm").submit();
    // this.qrcode();
  },
  methods: {
    async getPrice() {
      let res = await aPost2(api.queryPrice, {
        order_no: this.$route.query.order_no
      });
      if (res.data.errCode === "99999") {
        this.priceData = res.data.retData;
        this.card_type = res.data.retData.card_type;
        if (res.data.retData.unpay_count > 1) {
          this.dialogVisible = true;
        }
        this.amountList = res.data.retData.amountList;
        this.amount =
          this.currency === "HKD"
            ? (this.amountList[0].amount / 100).toFixed(2)
            : (this.amountList[1].amount / 100).toFixed(2);
        sessionStorage.setItem("amount", this.amount);
      } else {
        this.$message.error(`${res.data.errMsg}`);
      }
    },
    //查詢支付狀態
    async queryPayResult() {
      const params = {
        mer_order_no: this.$route.query.mer_order_no
      };
      const res = await aPost2(api.queryPayResult, params);
      if (res.data.errCode === "99999") {
        if (
          res.data.retData.order_result.order_status === "SUCC" ||
          res.data.retData.order_result.order_status === "FINISH"
        ) {
          this.$router.push({
            path: "/success",
            query: { order_id: this.$route.query.order_no }
          });
        } else {
          this.$message({
            message: "支付未完成！",
            type: "error"
          });
        }
      }
    },
    //倒計時
    startCounting() {
      this.count = 60;
      let that = this;
      that.isCounting = true;
      that.clock = setInterval(() => {
        if (that.count > 0) {
          that.count--;
        } else {
          that.isValid = false;
          that.index++;
          clearInterval(that.clock);
          that.clock = null;
          that.isCounting = false;
        }
      }, 1000);
    },
    //  生成二維碼
    qrcode() {
      let that = this;
      let qrcode = new QRCode(`qrcode`, {
        width: 300,
        height: 300, // 高度
        text: that.$route.query.pay_info
      });
      // this.startCounting();
    },
    back() {
      this.$router.go(-1);
    },
    getAmount() {
      this.amount =
        this.currency === "HKD"
          ? (this.amountList[0].amount / 100).toFixed(2)
          : Number(this.amountList[1].amount / 100).toFixed(2);
      sessionStorage.setItem("currency", this.currency);
      sessionStorage.setItem("amount", this.amount);
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  margin: 0 auto;
  width: 960px;
  font-size: 16px;
  padding: 40px 0;
  .m-header {
    padding: 10px;
    border: 1px dashed #fa800a;
    .amount {
      margin-right: 10px;
      color: #fa800a;
    }
  }

  .pay-box {
    position: relative;
    margin-top: 32px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
    padding: 16px;
    .label {
      margin-right: 32px;
    }
    .code-box {
      margin-right: 32px;
      .tips {
        font-size: 12px;
      }
    }
    .link {
      margin-top: 110px;
    }
    .scan-btn {
      width: 230px;
      height: 44px;
      background: #ff7674;
      color: #fff;
      font-size: 12px;
      line-height: 1.5;
      img {
        padding: 0 32px;
      }
    }
    .qr-code {
      width: 200px;
      height: 190px;
      padding: 20px;
      padding-right: 4px;
      border: 1px solid #eee;
      margin-bottom: 12px;
      .code {
        width: 200px;
        height: 200px;
      }
    }
    .paid-box {
      display: flex;
      justify-content: flex-end;
      width: 230px;
      margin-top: 40px;
      .paid {
        padding: 5px 12px;
        border: 1px solid #ccc;
        border-radius: 2px;
        cursor: pointer;
      }
    }
  }
}
</style>
